import { Eye, MousePointerClick, Users } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface PublicStatsDisplayProps {
  views: number;
  contactClicks?: number;
  uniqueVisitors?: number;
  variant?: "compact" | "full";
}

export const PublicStatsDisplay = ({
  views,
  contactClicks = 0,
  uniqueVisitors,
  variant = "compact"
}: PublicStatsDisplayProps) => {
  // Don't show if no meaningful stats
  if (views === 0 && contactClicks === 0) {
    return null;
  }

  const formatNumber = (num: number) => {
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1)}k`;
    }
    return num.toString();
  };

  if (variant === "compact") {
    return (
      <div className="flex items-center gap-3 text-sm text-muted-foreground">
        {views > 0 && (
          <span className="flex items-center gap-1">
            <Eye className="w-4 h-4" />
            {formatNumber(views)} visitas
          </span>
        )}
        {contactClicks > 0 && (
          <span className="flex items-center gap-1">
            <MousePointerClick className="w-4 h-4" />
            {formatNumber(contactClicks)} contactos
          </span>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      {views > 0 && (
        <Badge variant="secondary" className="gap-1.5">
          <Eye className="w-3 h-3" />
          {formatNumber(views)} visitas
        </Badge>
      )}
      {contactClicks > 0 && (
        <Badge variant="secondary" className="gap-1.5">
          <MousePointerClick className="w-3 h-3" />
          {formatNumber(contactClicks)} contactos
        </Badge>
      )}
      {uniqueVisitors && uniqueVisitors > 0 && (
        <Badge variant="secondary" className="gap-1.5">
          <Users className="w-3 h-3" />
          {formatNumber(uniqueVisitors)} visitantes
        </Badge>
      )}
    </div>
  );
};
